var _path, _circle, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAenaCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 18 H18 L22 12 H42 L46 18 H56 C58.2 18 60 19.8 60 22 V50 C60 52.2 58.2 54 56 54 H8 C5.8 54 4 52.2 4 50 V22 C4 19.8 5.8 18 8 18 Z",
    stroke: "#1A2732",
    strokeWidth: 3,
    strokeLinejoin: "round",
    fill: "none"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 36,
    r: 10,
    stroke: "#1A2732",
    strokeWidth: 3,
    fill: "none"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 25,
    r: 1.8,
    fill: "#1A2732"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAenaCamera);
export default __webpack_public_path__ + "static/media/aena_camera.8a1f5d0033ef460b5aca44318a8c9a5d.svg";
export { ForwardRef as ReactComponent };